<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/cjPYrX/tc-custom/9781466835658.jpg?1737195673599" alt="This image is the cover for the book If I Told You Once"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">If I Told You Once
      </h1>
      <p class="bookDescription body article font2">
        <p>In her utterly original novel about mothers, daughters, and love, Judy Budnitz gives the traditional folktale an electrifying twist as she follows four generations of women from an Eastern European village to the tenements of an American city. Elena, born into a family ruled by a formidable mother, embarks on an epic journey to the New World, met along the way by evil, magic, and good fortune. The daughter, grand-daughter, and great-granddaughter who follow each share her special powers of observation and, often, destruction. The result is a family saga unlike any other: a hilarious, heartbreaking story of family ties that bind.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Judy Budnitz
      </h2>
      
      <p class="authorDescription body article"><P><B>Judy Budnitz</B>'s stories have appeared in <I>Story, The Paris Review, Glimmer Train, </I>and <I>25</I> And Under. She lives in Manhattan.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Picador
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?62f77169